import React from "react";
import Headers from "./Headers";
import { Container } from "react-bootstrap";
import Coach from "./Coach";
import SEO from "./SEO";

export default function Coaches() {
  return (
    <>
      <SEO title="Coaches Gloves Up | Boxing Gym - Top Toronto Boxing Coaches" description="Meet the expert trainers behind Toronto’s best boxing gym. Our certified coaches are passionate about helping every member improve their skills and confidence in and out of the ring." />
      <div className="coaches" id="home">
        <h1 className="sr-only">Coaches Gloves Up | Boxing Gym - Top Toronto Boxing Coaches</h1>
        <p className="sr-only">
          Meet the experienced boxing coaches at Gloves Up in Toronto. Our team specializes in beginner boxing, kids classes, and advanced training. Passionate and community-driven since 2016.
        </p>
        <Headers title="Coaches" />
        <div className="coaches-body">
          <Container className="d-flex justify-content-center">
            <Coach />
          </Container>
        </div>
      </div>
    </>
  );
}
